module.exports = __webpack_public_path__ + "static/media/HindVadodara-SemiBold.507f1578.woff";